export default "__VITE_ASSET__C3MKvgjQ__"